import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const TextArea = styled.textarea(
  ({ theme }) => css`
    width: 100%;
    min-height: 80px;
    padding: ${theme.sz.s3};
    border: 1px solid ${theme.co.neutral80};
    border-radius: ${theme.sz.s1};
    font-size: 1rem;
    font-family: inherit;
    resize: vertical;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: ${theme.co.primary50};
    }

    &:disabled {
      background-color: ${theme.co.neutral95};
      color: ${theme.co.neutral50};
      cursor: not-allowed;
    }

    &::placeholder {
      color: ${theme.co.neutral60};
    }
  `,
);

export const ErrorMessage = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.error50};
    margin-top: ${theme.sz.s1};
  `,
);
